// extracted by mini-css-extract-plugin
export default {"box":"mnN7Lk9t3k6TRe1O38XS"};